export function farloUiPostCarousel(element) {
    let flktyPost = "";
    if (window.innerWidth <= 980) {
        flktyPost = new Flickity(element, {
            cellAlign: 'left',
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true,
            groupCells: false,
            freeScroll: false,
            draggable: true,
            dragThreshold: 1,
            autoPlay:6000,
        });
    } else {
        flktyPost = new Flickity(element, {
            cellAlign: 'left',
            pageDots: false,
            prevNextButtons: false,
            wrapAround: true,
            groupCells: false,
            freeScroll: false,
            draggable: true,
            dragThreshold: 1,
            autoPlay:6000,
        });
    }

    // Handle window resizing
    const onResize = () => {
        if (window.innerWidth <= 980) {
            flktyPost.destroy();
            flktyPost = new Flickity(element, {
                cellAlign: 'left',
                pageDots: true,
                prevNextButtons: false,
                wrapAround: true,
                groupCells: false,
                freeScroll: false,
                draggable: true,
                dragThreshold: 1,
                autoPlay:6000,
            });
        } else if (flktyPost != "") {
            flktyPost.destroy();
            flktyPost = new Flickity(element, {
                cellAlign: 'left',
                pageDots: false,
                prevNextButtons: false,
                wrapAround: true,
                groupCells: false,
                freeScroll: false,
                draggable: true,
                dragThreshold: 1,
                autoPlay:6000,
            });

        }

    };



    window.addEventListener('resize', onResize);
}
